// The workspace body: the drawer's only scroll surface, so its scrollbar sits
// at the sheet's right edge. The section nav scrollspies on it and scrolls it
// to the anchors the details panel renders.
export const INVOICE_SCROLL_CONTAINER_ID = "native-invoice-scroll-container";

export const INVOICE_SECTION_ANCHORS = {
    fromTo: "invoice-section-from-to",
    dates: "invoice-section-dates",
    items: "invoice-section-items",
    email: "invoice-section-email",
    additionalDetails: "invoice-section-additional-details",
    design: "invoice-section-design",
};
